import type { GetObligationAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import { GetObligationAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetObligationAuditByIdArgs = { id: string };

export const useGetObligationAuditById = createQueryHook<
  UseGetObligationAuditByIdArgs,
  GetObligationAuditByIdResponseRow[],
  AuditLogQueryResult<'obligation_audit', GetObligationAuditByIdResponseRow>
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getObligationAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ obligation_audit: data }),
  graphqlDocument: GetObligationAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
